import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Screen } from 'src/lib/flows/screens';

interface FormState {
  currentStep: Screen;
  formSubmitId?: string;
  initialScreen: Screen;
  pageNumber: number;
  visitedScreens: Screen[];
}

const initialState: FormState = {
  currentStep: '' as Screen,
  pageNumber: 0,
  initialScreen: '' as Screen,
  visitedScreens: [],
};

const formReducer = createSlice({
  name: 'form',
  initialState,
  reducers: {
    initializeForm(state, action: PayloadAction<FormState>) {
      return { ...state, ...action.payload };
    },
    setCurrentStep(state, action: PayloadAction<Screen>) {
      state.currentStep = action.payload;
    },
    setFormSubmitId(state, action: PayloadAction<string>) {
      state.formSubmitId = action.payload;
    },
    setInitialScreen(state, action: PayloadAction<Screen>) {
      state.initialScreen = action.payload;
    },
    setPageNumber(state, action: PayloadAction<number>) {
      state.pageNumber = action.payload;
    },
    setVisitedScreens(state, action: PayloadAction<Screen[]>) {
      state.visitedScreens = action.payload;
    },
  },
});

export const {
  initializeForm,
  setCurrentStep,
  setFormSubmitId,
  setInitialScreen,
  setPageNumber,
  setVisitedScreens,
} = formReducer.actions;
export default formReducer.reducer;
